import { IPathwayDocument, TDocumentListItem } from '../types/Documents';

const MONTHS_IT = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];


export const buildDateFilter = (
  selectedYears: string[],
  selectedMonths: string[],
): string[] => {
  const currentYear = new Date().getFullYear().toString();
  const monthIndices = selectedMonths
    .map(m => MONTHS_IT.indexOf(m) + 1)
    .filter(i => i > 0);
  const years = selectedYears.filter(Boolean);

  if (years.length === 0 && monthIndices.length === 0) return [];

  const ranges: string[] = [];

  if (years.length > 0 && monthIndices.length > 0) {
    for (const y of years) {
      for (const monthIndex of monthIndices) {
        const paddedMonth = String(monthIndex).padStart(2, '0');
        const lastDay = new Date(Number(y), monthIndex, 0).getDate();
        ranges.push(`${y}-${paddedMonth}-01,${y}-${paddedMonth}-${lastDay}`);
      }
    }
  } else if (years.length > 0) {
    for (const y of [...years].sort()) {
      ranges.push(`${y}-01-01,${y}-12-31`);
    }
  } else {
    for (const monthIndex of monthIndices) {
      const paddedMonth = String(monthIndex).padStart(2, '0');
      const lastDay = new Date(Number(currentYear), monthIndex, 0).getDate();
      ranges.push(`${currentYear}-${paddedMonth}-01,${currentYear}-${paddedMonth}-${lastDay}`);
    }
  }

  return ranges;
};

export const groupDocumentsByMonth = (
  documents: IPathwayDocument[],
): Record<string, IPathwayDocument[]> =>
  documents.reduce<Record<string, IPathwayDocument[]>>((acc, doc) => {
    const date = new Date(doc.createdAt);
    const monthName = new Intl.DateTimeFormat('it-IT', { month: 'long' }).format(date);
    const key = `${monthName.charAt(0).toUpperCase()}${monthName.slice(1)} ${date.getFullYear()}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(doc);
    return acc;
  }, {});


export const groupItemsByMonth = (
  items: TDocumentListItem[],
): Record<string, TDocumentListItem[]> => {
  const sorted = [...items].sort(
    (a, b) => new Date(b.data.createdAt).getTime() - new Date(a.data.createdAt).getTime(),
  );
  return sorted.reduce<Record<string, TDocumentListItem[]>>((acc, item) => {
    const date = new Date(item.data.createdAt);
    const monthName = new Intl.DateTimeFormat('it-IT', { month: 'long' }).format(date);
    const key = `${monthName.charAt(0).toUpperCase()}${monthName.slice(1)} ${date.getFullYear()}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
};

export const formatDocumentDate = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    });
  } catch {
    return dateString;
  }
};
